import { createRouter, createWebHistory, START_LOCATION } from "vue-router";
import Swal from 'sweetalert2';

import Home from '../pages/HomePage.vue';
// ... (imports remain same, I will use ReplaceFileContent on targeted lines to be safe)
import About from '../pages/AboutPage.vue';
import Contact from '../pages/ContactPage.vue';
import Suggestion from '../pages/SuggesstionPage.vue';
import Subscribe from '../pages/SubscribePage.vue';
import ProfilePage from '../pages/ProfilePage.vue';
import Login from '../pages/AuthPage.vue';
import EditorialDetail from '../pages/EditorialDetail.vue';
import VisionPage from '../pages/VisionPage.vue';
import AdminDashboard from '../pages/AdminPage.vue';
import GalleryPage from '../pages/GalleryPage.vue';
import Dashboard from '../components/DashboardView.vue';
import AdminUsers from '../components/AdminUsers.vue';
import AdminEditorials from '../components/AdminEditorials.vue';
import AdminArtist from '../components/AdminArtist.vue';
import ContactForm from '../components/ContactForm.vue';
import NewspaperSection from '../components/NewspaperSection.vue';
import MagazineSection from '../components/AdminMagazine.vue';
import ArtistPage from '../pages/ArtistPage.vue'
import AllArtistsPage from '../pages/AllArtistsPage.vue';
import AdminSuggestion from '../components/AdminSuggestion.vue';
import AdminAds from '../components/AdminAds.vue';

const routes = [
  { path: '/', name: 'Home', component: Home, meta: { title: 'Home - Sanskritir Dapon' } },
  { path: '/vision', name: 'Vision', component: VisionPage, meta: { title: 'Vision - Sanskritir Dapon' } },
  { path: '/about', name: 'About', component: About, meta: { title: 'About Us - Sanskritir Dapon' } },
  { path: '/suggestion', name: 'Suggestion', component: Suggestion, meta: { title: 'Suggestions - Sanskritir Dapon' } },
  { path: '/contact', name: 'Contact', component: Contact, meta: { title: 'Contact Us - Sanskritir Dapon' } },
  { path: '/subscribe', name: 'Subscribe', component: Subscribe, meta: { requiresAuth: true, title: 'Subscribe - Sanskritir Dapon' } },
  { path: '/profile', name: 'ProfilePage', component: ProfilePage, meta: { title: 'User Profile - Sanskritir Dapon' } },
  { path: '/login', name: 'Login', component: Login, meta: { title: 'Login - Sanskritir Dapon' } },
  { path: '/editorial/:id', name: 'EditorialDetail', component: EditorialDetail, meta: { title: 'Editorial - Sanskritir Dapon' } },
  { path: '/profile/:id', name: 'ArtistProfile', component: ProfilePage, meta: { title: 'Artist Profile - Sanskritir Dapon' } },
  { path: '/artist', name: 'SoloProfile', component: ArtistPage, meta: { requiresAuth: true, title: 'My Artist Profile' } },
  { path: '/artists', name: 'AllArtists', component: AllArtistsPage, meta: { title: 'All Artists - Sanskritir Dapon' } },
  { path: '/gallery', name: 'GalleryPage', component: GalleryPage, meta: { title: 'Gallery - Sanskritir Dapon' } },

  // 🔒 Admin Section (protected routes)
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requiresAdmin: true },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboardMain',
        component: Dashboard,
        meta: { requiresAdmin: true }
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: AdminUsers,
        meta: { requiresAdmin: true }
      },
      {
        path: 'editorials',
        name: 'AdminPosts',
        component: AdminEditorials,
        meta: { requiresAdmin: true }
      },
      {
        path: 'artist',
        name: 'AdminSettings',
        component: AdminArtist,
        meta: { requiresAdmin: true }
      },
      {
        path: 'contact',
        name: 'ContactForm',
        component: ContactForm,
        meta: { requiresAdmin: true }
      },
      {
        path: 'newspaper',
        name: 'newspaperSection',
        component: NewspaperSection,
        meta: { requiresAdmin: true }
      },
      {
        path: 'magazine',
        name: 'magazineSection',
        component: MagazineSection,
        meta: { requiresAdmin: true }
      },
      {
        path: 'suggestions',
        name: 'AdminSuggestions',
        component: AdminSuggestion,
        meta: { requiresAdmin: true }
      },
      {
        path: 'advertisements',
        name: 'AdminAds',
        component: AdminAds,
        meta: { requiresAdmin: true }
      },
      {
        path: '',
        redirect: '/admin/dashboard' // Redirect /admin to /admin/dashboard
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to, from, savedPosition) {
    // For browser back/forward button (but not on a page refresh,
    // which should always start at the top)
    if (savedPosition && from !== START_LOCATION) {
      // Page content loads from the API after navigation, so wait (max 1.5s)
      // until the page is tall enough to scroll back to the saved spot
      return new Promise((resolve) => {
        const started = Date.now();
        const tryRestore = () => {
          const tallEnough = document.documentElement.scrollHeight >= savedPosition.top + window.innerHeight;
          if (tallEnough || Date.now() - started > 1500) resolve(savedPosition);
          else setTimeout(tryRestore, 50);
        };
        tryRestore();
      });
    }

    // Always scroll to top on route change
    return { top: 0 };
  }
});

// 🧠 Global Navigation Guard
router.beforeEach((to, from, next) => {
  // Set document title
  const defaultTitle = 'Sanskritir Dapon - Cultural Magazine';
  document.title = to.meta.title || defaultTitle;

  const user = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');

  // 🔒 Check if route requires login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user || !token) {
      Swal.fire({
        icon: 'warning',
        title: 'Login Required',
        text: 'Please log in to access this page.',
        confirmButtonColor: '#BF3131',
        showCancelButton: true,
        confirmButtonText: 'Go to Login',
        cancelButtonText: 'Cancel'
      }).then(result => {
        if (result.isConfirmed) router.push('/login');
      });
      return next(false); // block navigation
    }
  }

  // 🔒 Check if route requires admin privileges
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (!user || !token) {
      Swal.fire({
        icon: 'warning',
        title: 'Login Required',
        text: 'Please log in first.',
        confirmButtonColor: '#BF3131'
      });
      return next('/login');
    } else if (user.role !== 'admin') {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: 'Admins only.',
        confirmButtonColor: '#BF3131'
      });
      return next('/');
    }
  }

  next();
});

export default router;
